
import React, { useState } from 'react';
import { PortfolioItem } from './PortfolioItem';
import { EditPortfolioItem } from './EditPortfolioItem';

interface PortfolioItemData {
  id: string;
  title: string;
  description?: string;
  image_url?: string;
  project_url?: string;
}

interface PortfolioGridProps {
  items: PortfolioItemData[];
  isOwner?: boolean;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  onUpdate?: () => void;
}

export const PortfolioGrid: React.FC<PortfolioGridProps> = ({
  items,
  isOwner = false,
  onEdit,
  onDelete,
  onUpdate
}) => {
  const [editingItemId, setEditingItemId] = useState<string | null>(null);

  const handleEditClick = (id: string) => {
    setEditingItemId(id);
    if (onEdit) onEdit(id);
  };

  const handleEditComplete = () => {
    setEditingItemId(null);
    if (onUpdate) onUpdate();
  };

  const handleEditCancel = () => {
    setEditingItemId(null);
  };

  if (items.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500 dark:text-gray-400">
          {isOwner ? "You haven't added any portfolio items yet." : "No portfolio items to display."}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((item) => (
        <div key={item.id}>
          {editingItemId === item.id ? (
            <EditPortfolioItem
              item={item}
              onUpdate={handleEditComplete}
              onCancel={handleEditCancel}
            />
          ) : (
            <PortfolioItem
              id={item.id}
              title={item.title}
              description={item.description || undefined}
              imageUrl={item.image_url || undefined}
              projectUrl={item.project_url || undefined}
              isOwner={isOwner}
              onEdit={handleEditClick}
              onDelete={onDelete}
            />
          )}
        </div>
      ))}
    </div>
  );
};
